
// 内容删除
import request from '@/utils/request.js'

// 删除的方法
export const questionBankDel =(bankId)=>{
    return request.get(
        '/questionBand/questionBandDel',
        {
            params:{
                bankId:bankId
            }
        }
    )
}